import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base-query';

const legalAPI = createApi({
  reducerPath: 'legalAPI',
  baseQuery,
  endpoints: (builder) => ({
    getLegalDocumentByType: builder.mutation({
      query: ({ type }) => ({
        url: `legal/documents/${type}`,
        method: 'GET',
      }),
      transformResponse: (response) => response,
    }),
    updateLegalDocument: builder.mutation({
      query: ({ type, payload }) => ({
        url: `legal/admin/documents/${type}`,
        method: 'PUT',
        body: payload,
      }),
    }),

    getCancellationCharges: builder.mutation({
      query: () => ({
        url: `legal/charges`,
        method: 'GET',
      }),
      transformResponse: (response) => response,
    }),
    updateCancellationCharges: builder.mutation({
      query: (payload) => ({
        url: `legal/admin/charges`,
        method: 'PUT',
        body: payload,
      }),
    })
  }),
});

export const { 
  useGetLegalDocumentByTypeMutation,
  useUpdateLegalDocumentMutation,

  useGetCancellationChargesMutation,
  useUpdateCancellationChargesMutation
} = legalAPI;

export default legalAPI;